import React from 'react';
import { withRouter } from 'react-router-dom';
import { withApollo } from "react-apollo";
import { CommentFeed } from "../comment";
import { ChannelMedia } from "../channel";
import { updateChannelView } from '../../graphql/mutations';
import { channelsUnread } from '../../graphql/queries'


class ChannelDetail extends React.Component {

	//@todo ... this looks wrong.
	componentDidMount() {
		this.mutate();
	}
	componentDidUpdate() {
		this.mutate();
	}

	mutate = () => {
		this.props.client.mutate({
			mutation: updateChannelView,
			variables: {
				id: this.props.match.params.id
			},
			refetchQueries: [{
				query: channelsUnread
			}]
		})
		.catch(e => {
			console.error('Update Channel View Error: ', e);
		}); 
	}

	render() {

		const channelId = this.props.match.params.id;

		return (
			<React.Fragment>
				<CommentFeed channelId={channelId} />
				<ChannelMedia channelId={channelId} />
			</React.Fragment>
		)
	}
}

export default withRouter(withApollo(ChannelDetail))


// WEBPACK FOOTER //
// ./src/components/channel/ChannelDetail.js